export const proposals = () => {
  return {
    labels: {
      proposal: 'Proposal',
      submit_date: 'Submit date',
      service_provided: 'Service Provided for',
      add_attachment: 'Add attachment',
      client: 'Client',
      location: 'Location',
      approver: 'Designated Approver',
      contact: 'Contact Person',
      priority: 'Priority',
      trade: 'Trade',
      product_or_service: 'Product or Service',
      leave_page: 'Leave Page',
      continue: 'Continue Editing',
      sort: 'Sort',
      highest: 'Highest',
      lowest: 'Lowest',
      newest: 'Newest',
      oldest: 'Oldest',
      clear: 'Clear',
      select_one: 'Select one',
      proposals_linked: 'Proposals linked',
      related_wo_title: 'Related Work Order Information',
      wo_number: 'Work Order #',
      wo_notes: 'Work Order Notes',
      direct_link: 'Direct Link'
    },
    placeholder: {
      description: 'Type in your proposal description',
      item_desc: 'Enter Description',
      select_one: 'Select one',
      select_priority: 'Select Priority',
      select_trade: 'Select Trade'
    },
    column_names: {
      client_name: 'Client Name',
      client_location: 'Location',
      proposal_id: 'Proposal #',
      workorder_number: 'Work Order #',
      submitted_date: 'Submitted Date',
      approved_date: 'Approval Date',
      approved_by: 'Designated Approver',
      status: 'Status',
      priority: 'Priority',
      trade: 'Trade',
      description: 'Proposal Description',
      item: 'Item',
      item_description: 'Description',
      tax: 'Tax % (Amount)',
      rate: 'Rate',
      quantity: 'Qty',
      amount: 'Amount'
    },
    status: {
      approved: 'Approved',
      closed: 'Closed',
      draft: 'Draft',
      declined: 'Declined',
      in_review: 'In Review',
      pending_decision: 'Pending Decision'
    },
    actions: {
      submit: 'Submit',
      save: 'Save Draft',
      add_item: 'Add Item',
      add_proposal: 'Add New Proposal',
      link_proposal: 'Link Existing Proposal',
      paste_description: 'Copy WO Description'
    },
    audit: 'Audit Trail',
    audit_actions: {
      create: 'Proposal generated',
      edit: 'Proposal saved as a draft',
      submit: 'Proposal submitted',
      reject: 'Proposal declined',
      approve: 'Proposal approved',
      review: 'Proposal in review'
    },
    tooltips: {
      proposal_id:
        'The ID is editable so you can use your own Proposal ID. The ID can be numbers or letters and must be unique. The first 3 letters are your unique company code and can not be changed.',
      status:
        'Fill out your Proposal and submit for approval. You can also save as a Draft and submit it later.',
      approver:
        'Captures the person responsible for approving the Proposal, or who requested the Proposal.',
      copy: 'Copy Work Order Description in the Proposal Description field, this will provide you with a starting point for the Proposal Description.'
    },
    summary: {
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'Total Amount'
    },
    error: {
      id_in_use: 'This ID has already been used',
      update_error: 'The record was not updated'
    },
    messages: {
      success_title: 'Proposal Saved',
      proposal_number: 'Proposal %NUMBER%',
      success_message: ' was successfully Saved. ',
      leave_title: 'You have unsaved changes on this Proposal.',
      leave_title2: 'If you leave this page these changes will be lost.',
      leave_secondary: 'Are you sure you want to leave this page?',
      empty_message_title: 'You do not have any Proposals',
      empty_message: 'You can create a Proposal from a WO or a non-linked Proposal by clicking "Create Proposal" on this page.',
      empty_message_filters:
      'Your search did not return any results. Check your search criteria and try again.'
    }
  }
}
